import React from 'react';
import PropTypes from 'prop-types';

import { DialogContent as MUIDialogContent } from '@material-ui/core';

export const DialogContent = props => <MUIDialogContent {...props} />;

DialogContent.propTypes = {
  classes: PropTypes.object,
  dividers: PropTypes.bool
};

export default DialogContent;
